module.exports = __webpack_public_path__ + "img/bank_12.e56f0711.png";